import React from 'react'
import {useIntl} from 'react-intl'

const Loading = () => {
  const intl = useIntl()

  return (
    <div className='page-loader flex-column bg-dark bg-opacity-50'>
      <span className='spinner-border text-primary' role='status'></span>
      <span className='text-light fs-6 fw-semibold mt-5'>
        {intl.formatMessage({id: 'LOADING'})}
      </span>
    </div>
  )
}

export {Loading}
